/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import GlobalSettings from '@/GlobalSettings'
import store from '../../store'
import Category, { colorList } from './Category'
import PrinterGroup from '../print/PrinterGroup'
import Allergen from './Allergen'
import StringEntity from '../common/StringEntity'
import AttributeGroup from './AttributeGroup'
import dayjs from 'dayjs'
import IKUtils from 'innerken-js-utils'
import i18n from '@/i18n'

const showImage = Boolean(GlobalSettings.isShowOnTable === '0')

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    form: false,
    requiredNew: false,
    header: false,
  },

  image: {
    type: IKDataEntity.Types.Image,
    formConfig: {
      type: {
        root: () => store.getters.rootUrl + GlobalSettings.dishImageRoot,
      },
      required: false,
      hint: 'recommended_picture_size_512x512', // 建议图片尺寸为512*512
    },
    tableConfig: {
      filterable: false,
      sortable: false,
    },
    displayName: ' ',
    header: showImage,
  },
  color: {
    type: IKDataEntity.Types.Color,
    formConfig: {
      default: colorList[Math.round(Math.random() * 18)],
      required: false,
      hint: 'selected_color_will_be_used_in_orderDevice', // 此处选择的颜色将会显示在员工使用的点餐设备上
    },
    header: false,
    tableConfig: { filterable: false },
  },
  code: {
    tableConfig: {
      width: '160',
    },
    formConfig: {
      rule: [],
      unique: true,
      hint: 'products_will_be_sorted_by_number_eg_1_1a_2',
    },
  },
  price: {
    type: IKDataEntity.Types.Float,
    formConfig: {
      default: '',
      overwriteRule: true,
      rule: [v => /^[0-9]+\.{0,1}[0-9]{0,2}$/.test(v) || i18n.t('pls_enter_a_right_price')],
      hint: 'use_dot_as_the_decimal_point_Negative_prices_are_not_allowed',
    },

    header: false,
  },
  dishName: {
    displayName: 'name',
    form: false,
    tableConfig: { overwrite: true },

  },

  langs: {
    displayName: 'name',
    type: IKDataEntity.Types.Group,
    formConfig: {
      groupName: 'product_info', // 商品信息
      default: GlobalSettings.supportLang,
      childLabelKey: 'lang',
      type: {},
    },
    tableConfig: {
      displayCondition: (item) => {
        return item.lang.toLowerCase() === GlobalSettings.getLang().toLowerCase()
      },
      displayChild: (key) => {
        return key === 'name'
      },
    },
    childKey: ['name', 'desc'],
    labelKey: 'lang',
    children: [StringEntity, StringEntity, StringEntity],
    header: false,
  },

  categoryId: {
    displayName: 'prokuct_series', // prokuct_series
    tableConfig: { filterable: false },
    type: IKDataEntity.Types.Option,
    formConfig: {
      hint: 'dishBelongClassify', // 商品所属的分类
      type: {
        showButton: true,

        selectItems: async () => {
          return await Category.getList(true)
        },
        itemText: '_langsname',
      },
    },
  },
  printGroupId: {
    displayName: 'printCatName',
    type: IKDataEntity.Types.Option,
    formConfig: {
      default: 1,
      type: {
        selectItems: PrinterGroup.getList,
      },
    },
    header: false,
  },
  priceDisplay: {
    displayName: 'price',
    type: IKDataEntity.Types.Float,
    form: false, // header: false,
  },
  AllergenId: {
    displayName: 'allergName', // 过敏药
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        showButton: true,
        selectItems: Allergen.getList,
        multiple: true,
      },
      required: false,
    },
    header: false,
  },
  attributeGroupId: {
    displayName: 'attributeGroupNames',
    type: IKDataEntity.Types.Option,
    formConfig: {
      required: false,
      type: {
        selectItems: AttributeGroup.getList,
        multiple: true,
        disabledItem: (item, editedItem) => {
          if (editedItem.inheritAttributeGroupId) {
            return ({
              ...item,
              disabled: editedItem.inheritAttributeGroupId.includes(item.id),
            })
          } else {
            return item
          }
        },
      },
    },
    header: false,
  },
  localAttributeGroupId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: AttributeGroup.getList,
        multiple: true,
      },
    },
    form: false,
    header: false,
  },
  inheritAttributeGroupId: {
    displayName: 'AttributeGroupName',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: AttributeGroup.getList,
        multiple: true,
      },
    },
    form: false,
    header: false,
  },
  dishWeight: {
    displayName: 'DishWeight',
    type: IKDataEntity.Types.Integer,
    formConfig: {
      default: 1,
      required: false,
      rule: [v => /^[0-9]\d*$/.test(v) || 'Bitte geben Sie die ganze Zahl ein'],
      hint: 'this_setting_will_change_the_click_times_on_the_product', // 此处的设置将会影响商品在包餐中所使用的点数。例如，将此处的点数设置为2，意味着每点一个本商品等于点了两个其他商品。
    },
    header: false,
  },
  isActive: {
    displayName: 'on_shelves', // 上架
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true,
      required: false,
    },
    tableConfig: {
      width: '100px',
    },
  },
  extraPrintGroupIds: {
    displayName: 'extraPrintGroup',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        multiple: true,
        selectItems: PrinterGroup.getList,
      },
      hint: 'extrenal_printer_print_same_bill', // 如果在此设置了额外打印机，那么商品除了正常的出单外，还会额外在此处设置的打印机出一份相同的厨房单
      required: false,
    },
    header: false,
  },
  attrLimit: {
    type: IKDataEntity.Types.Integer,
    formConfig: {
      required: false,
      default: -1,
    },
    header: false,
  },

}

const config = {

  load: async function (filter) {
    return (await hillo.get('Dishes.php', {
      lang: GlobalSettings.getLang(),
      onlyActive: 0,
      ...filter,
    }))
      .content.map(function (item) {
        item.displayCode = item.code.length > 5 ? item.code.slice(0, 5) + '...' : item.code
        item.id = item.dishId
        item.attributeGroupId = [item.inheritAttributeGroupId ? item.inheritAttributeGroupId.split(',') : [], item.localAttributeGroupId ? item.localAttributeGroupId.split(',') : []].flat().join(',')
        item.langs = item.langs.map(i => {
          return {
            ...i,
            desc: i.description,
          }
        })
        item.priceDisplay = item.price
        return item
      })
  },
  add: async function (item) {
    item.attributeGroup = ''
    item.allergenGroup = [item?.AllergenId].flat().join(',') ?? ''
    item.extraPrintGroupIds = [item?.extraPrintGroupIds].flat().join(',') ?? ''
    if (item.code === '自动生成') {
      const codes = await loadAllCode()
      for (let i = 0; i < 10000; i++) {
        if (!codes.includes(i.toString())) {
          item.code = i
        }
      }
      if (item.code === '自动生成') {
        item.code = dayjs().utcOffset()
      }
    }
    return (await hillo.postWithUploadFile('Dishes.php?op=add', {
      ...item,
      params: JSON.stringify(item),
    }, { showLoading: false })).content
  },

  remove: async function (id) {
    IKUtils.showLoading()
    try {
      await hillo.post('Dishes.php?op=delete', { id })
    } catch (e) {
      await hillo.post('Dishes.php?op=softDelete', { id: id })
    }
    return true
  },
  edit: function (item) {
    item.attributeGroup = item
      ?.attributeGroupId
      ?.filter(i => !item.inheritAttributeGroupId.includes(i)).join(',') ?? ''
    item.allergenGroup = item?.AllergenId?.join(',') ?? ''
    item.extraPrintGroupIds = item?.extraPrintGroupIds?.join ? item.extraPrintGroupIds.join(',') : ''
    if (item.file) {
      item.imageExt = item.file.name.split('.')[1]
    }
    item.isActive = item.isActive ? 1 : 0
    console.log(item)

    return hillo.postWithUploadFile('Dishes.php?op=update', {
      ...item,
      params: JSON.stringify(item),
    }, { showLoading: false })
  },
  nameBuilder: function (item) {
    return item.code + '.' + item.dishName
  },


}

export async function loadAllCode () {
  return (await hillo.get('Dishes.php', {
    onlyActive: 0,
  })).content.map(it => it.code)
}

const DishModel = IKDataEntity.ModelFactory(entity, config)
DishModel.getBuffet = async function () {
  return (await DishModel.getList()).filter(i => i.dishesCategoryTypeId === '8')
}
export default DishModel
